import React from 'react';
import { Modal } from 'carbon-components-react';
import { postTempConfigFile } from '../../../../../../../actions/index';
import funcTranslateHelper from '../../../../../../../i18next/funcTranslateHelper';

function DeleteteStage (props) {
  const { stage, configFile, setConfigFile, open, handleClose } = props;

  async function deleteStageFromConfigFile () {
    const config = {
      ...configFile,
      stages: configFile.stages.filter(e => e.id !== stage.id)
    };
    await postTempConfigFile(config);
    setConfigFile(config);
    handleClose(false);
  }

  return (
    <Modal
      danger
      iconDescription={funcTranslateHelper('Cerrar')}
      modalAriaLabel='A label to be read by screen readers on the modal root node'
      modalHeading={funcTranslateHelper('Builder.builder.deleteStage.modalHeading')}
      modalLabel={funcTranslateHelper('Builder.builder.deleteStage.modalLabel')}
      onRequestClose={() => handleClose(false)}
      onRequestSubmit={deleteStageFromConfigFile}
      onSecondarySubmit={() => handleClose(false)}
      open={open}
      primaryButtonText={funcTranslateHelper('Aceptar')}
      secondaryButtonText={funcTranslateHelper('Cancelar')}
      aria-label='Modal'
    />
  );
}

export default DeleteteStage;
